import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import HomePage from './pages/HomePage/HomePage';
import TestPage from './pages/TestPage/TestPage';
import Login from './pages/LoginPage/Login';
import Success from './pages/SuccessPage/Success';
import PurchaseCredits from './pages/PurchaseCredits/PurchaseCredits';
import Spinner from './components/Spinner/Spinner';
import LandingPage from './pages/LandingPage/LandingPage';
import SignUpPage from './pages/SignUpPage/SignUpPage';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import RedeemCode from './pages/RedeemCode/RedeemCode';
import AdHistoryPage from './pages/AdHistory/AdHistoryPage';
import AdHistoryRedeem from './pages/AdHistory/AdHistoryRedeem'; // Import the AdHistoryRedeem component
import Impressum from './pages/Impressum/Impressum';

const App = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    // Redirect to /app if authenticated and trying to access the root
    if (isAuthenticated && location.pathname === '/') {
      window.history.replaceState({}, '', '/app');
    }
  }, [isAuthenticated, location.pathname]);

  if (isLoading) return <Spinner />;

  // Determine if redeem code is present in local storage
  const isRedeemUser = Boolean(localStorage.getItem('redeem_code'));

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={isAuthenticated ? <Navigate to="/app" /> : <LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/impressum" element={<Impressum />} />

      {/* Authenticated Routes */}
      <Route path="/app" element={isAuthenticated ? <HomePage /> : <Navigate to="/login" />} />
      <Route path="/purchase-credits" element={isAuthenticated ? <PurchaseCredits /> : <Navigate to="/login" />} />
      <Route path="/success" element={isAuthenticated ? <Success /> : <Navigate to="/login" />} />
      
      {/* Ad History Routes based on user type */}
      <Route path="/ad-history" element={isAuthenticated ? <AdHistoryPage /> : isRedeemUser ? <Navigate to="/redeem-history" /> : <Navigate to="/login" />} />
      <Route path="/redeem-history" element={isRedeemUser ? <AdHistoryRedeem /> : <Navigate to="/redeem" />} />

      {/* Redeem Code Routes */}
      <Route path="/redeem" element={<RedeemCode />} />

      {/* General Routes */}
      <Route path="/test-app" element={<TestPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default App;
